import { connect } from "react-redux";
import LedgerListing from "./ledgerListing";
import { bindActionCreators } from "redux";
import { getLedgerListing,downloadLedger } from "services/redux/sales/approvedSalesListing/action";

import {
  fetchZones,
  getListFilterData,
} from "services/redux/sales/preSaleListing/action";

const mapStateToProps = (state) => ({
  ledgerlistData: state.approvedSalesListReducer.ledgerList,
  getFetchZones: state.preSalesListReducer.getFetchZones,
  filterDropdownList: state.preSalesListReducer.filterDropdownList,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getListFilterData,
      fetchZones,
      getLedgerListing,
      downloadLedger
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(LedgerListing);
